module.exports = __webpack_public_path__ + "media/images/icons/flist_short-2e124749e53c20436e85ac8b9d827a21.svg";